import React from 'react'
import SidebarNavItem from './SidebarNavItem'

const MobileSidebar = ({
  isOpen,
  onClose,
  activeTab,
  onTabClick,
  onLogout,
  isLoggingOut,
}) => {
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}
      <nav
        className={`lg:hidden fixed left-0 top-0 h-full w-72 max-w-[85vw] bg-white shadow-xl z-50 transform transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="pt-20">
          <div className="mt-16">
            <SidebarNavItem
              icon="fas fa-shopping-bag"
              label="შეკვეთები"
              tabName="orders"
              activeTab={activeTab}
              onTabClick={onTabClick}
              isMobile={true}
            />
            <SidebarNavItem
              icon="fas fa-user"
              label="პროფილი"
              tabName="profile"
              activeTab={activeTab}
              onTabClick={onTabClick}
              isMobile={true}
            />
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-6 border-t border-slate-100">
          <button
            className="w-full text-[15px] px-4 py-3 bg-slate-50 text-slate-600 border border-slate-200 rounded-xl cursor-pointer font-medium transition-all duration-200 flex items-center justify-center gap-2 hover:bg-red-50 hover:text-red-600 hover:border-red-200 disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={onLogout}
            disabled={isLoggingOut}
          >
            <i className="fas fa-sign-out-alt"></i>
            გამოსვლა
          </button>
        </div>
      </nav>
    </>
  )
}

export default MobileSidebar
